import { Controller } from "@hotwired/stimulus"
import { Tooltip } from 'bootstrap'

export default class extends Controller {
  static targets = ['tooltip']

  connect() {
    this.tooltipTargets.forEach(e => new Tooltip(e))
  }
}
